import type { AutoFormInputComponentProps } from "../types"
import { useTranslations } from "next-intl"
import { FormControl, FormItem, FormMessage } from "@/components/ui/form"
import { Label } from "@/components/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { cn } from "@/lib/utils"
import AutoFormLabel from "../common/label"
import AutoFormTooltip from "../common/tooltip"

export default function GenderRadioGroup({
  label,
  isRequired,
  fieldConfigItem,
  field,
}: AutoFormInputComponentProps) {
  const t = useTranslations()
  const disabled = fieldConfigItem?.inputProps?.disabled

  return (
    <div className={cn("flex flex-row items-center space-x-2", fieldConfigItem?.containerClassName)}>
      <FormItem className="flex w-full flex-col justify-start">
        <AutoFormLabel
          isRequired={isRequired}
          label={fieldConfigItem?.label || label}
        />
        <FormControl>
          <RadioGroup
            className="flex flex-wrap gap-4"
            disabled={disabled}
            onValueChange={field.onChange}
            value={field.value}
          >
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                disabled={disabled}
                id="male"
                value="M"
              />
              <Label htmlFor="male">
                {t("generic.sport_settings.new_event_dialog.genders.male")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                disabled={disabled}
                id="female"
                value="W"
              />
              <Label htmlFor="female">
                {t("generic.sport_settings.new_event_dialog.genders.female")}
              </Label>
            </div>
            <div className="flex items-center space-x-2">
              <RadioGroupItem
                disabled={disabled}
                id="mixed"
                value="X"
              />
              <Label htmlFor="mixed">
                {t("generic.sport_settings.new_event_dialog.genders.mixed")}
              </Label>
            </div>
          </RadioGroup>
        </FormControl>
        <AutoFormTooltip fieldConfigItem={fieldConfigItem} />
        <FormMessage />
      </FormItem>
    </div>
  )
}
